<template>
<div class="modal fade" id="modalUploadBast" role="dialog" @shown="checkData">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="change-title">
          <h4 class="modal-title">{{ type }} Bukti Penyerahan</h4>
        </div>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <!-- Product Information Section -->
        <div class="card p-3 mb-3">
          <div class="mb-2">
            <strong>Product Information</strong>
            <p class="m-0 mt-1 text-subtitle">Detail produk yang akan di-upload</p>
          </div>
          <table class="table table-sm table-bordered table-striped table-responsive-sm payment table-fixed">
            <thead>
              <tr>
                <th>Category</th>
                <th>Type</th>
                <th class="fixed-width">Require Specification</th>
                <th class="fixed-width">Actual Specification</th>
                <th>Qty</th>
                <th>Product Code</th>
              </tr>
            </thead>
            <tbody v-if="loadingTableGenerate">
              <tr>
                <td colspan="6" class="text-center"><img src="~@/assets/images/load-button.gif" /></td>
              </tr>
            </tbody>
            <tbody v-else-if="!loadingTableGenerate && !bastItem">
              <tr>
                <td colspan="6" class="text-center">Data Not Available</td>
              </tr>
            </tbody>
            <tbody v-else-if="!loadingTableGenerate && bastItem">
              <tr v-for="(data,i) in bastItem" :key="i">
                <td>
                  {{data.category}}
                </td>
                <td>
                  {{data.type}}
                </td>
                <td>
                  {{data.specificationsView}}
                </td>
                <td v-if="data.actualSpecificationsView">
                  {{data.actualSpecificationsView}}
                </td>
                <td v-else>
                  <div v-for="(item,i) in data.bomItem" :key="`${item.itemName}-${i}`">
                    <div v-for="(qty,j) in item.itemQty" :key="`${item.itemName}Detail-${i}-${j}}`">
                      {{item.itemName}}
                    </div>
                  </div>
                </td>
                <td>
                  {{data.qty}}
                </td>
                <td>
                  {{data.listOrderLP}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Dokumen Penyerahan Section -->
        <div class="card p-3 mb-3">
          <div class="mb-2">
            <strong>Dokumen Penyerahan</strong>
            <p class="m-0 mt-1 text-subtitle">Upload BAST yang sudah ditandatangani dan dokumen pendukung</p>
          </div>
          <table class="table-fixed">
            <tbody>
              <tr>
                <td><div class="ol-label">BAST yang sudah di ttd</div></td>
                <td>:</td>
                <td>
                  <div class="file-input-custom" @click="triggerFileInput('upgrade-file-1')">
                    <div class="file-button">Choose File</div>
                    <div class="file-name">{{ fileName1 || 'No file chosen' }}</div>
                  </div>
                  <input type="file" id="upgrade-file-1" @change="onFilePicked($event, 1)" class="hidden-input">
                </td>
              </tr>
              <br>
              <tr>
                <td><div class="ol-label" style="width: 200px;">Bukti Penyerahan (Jika ada)</div></td>
                <td>:</td>
                <td>
                  <div class="file-input-custom" @click="triggerFileInput('upgrade-file-2')">
                    <div class="file-button">Choose File</div>
                    <div class="file-name">{{ fileName2 || 'No file chosen' }}</div>
                    <div v-if="fileName2" @click="removeImage($event,'upgrade-file-2')" class="delete-image-icon">
                      &times;
                    </div>
                  </div>
                  <input type="file" id="upgrade-file-2" @change="onFilePicked($event, 2)" class="hidden-input">
                </td>
              </tr>
              <br>
              <tr>
                <td><div class="ol-label">Resi (Jika ada)</div></td>
                <td>:</td>
                <td>
                  <div class="file-input-custom" @click="triggerFileInput('upgrade-file-3')">
                    <div class="file-button">Choose File</div>
                    <div class="file-name">{{ fileName3 || 'No file chosen' }}</div>
                    <div v-if="fileName3" @click="removeImage($event,'upgrade-file-3')" class="delete-image-icon">
                      &times;
                    </div>
                  </div>
                  <input type="file" id="upgrade-file-3" @change="onFilePicked($event, 3)" class="hidden-input">
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Asani PIC Section -->
        <div class="card p-3 mb-3">
          <div class="mb-2">
            <strong>Asani PIC</strong>
            <p class="m-0 mt-1 text-subtitle">Informasi PIC dari pihak Asani</p>
          </div>
          <table>
            <tbody>
              <tr>
                <td><div class="ol-label">Name</div></td>
                <td>:</td>
                <td>
                  <multiselect 
                    class="w-100"  
                    v-model="searchPic" 
                    :options="picSelect" 
                    label="picName" 
                    :allow-empty="false" 
                    :select-label="''" 
                    :deselect-label="''" 
                    placeholder="PIC Name" 
                    track-by="picName"
                  >
                    <template slot="singleLabel" slot-scope="props"  >
                      <div class="font-14">
                        {{ props.option.picName }}
                      </div>
                    </template>
                  </multiselect>
                </td>
              </tr>
              <br>
              <tr>
                <td><div class="ol-label">Role</div></td>
                <td>:</td>
                <td>
                  <input type="text" class="form-control" placeholder="PIC Role" v-model="picRole">
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Lessee PIC Section -->
        <div class="card p-3">
          <div class="mb-2">
            <strong>Lessee PIC</strong>
            <p class="m-0 mt-1 text-subtitle">Informasi PIC dari pihak Lessee</p>
          </div>
          <table>
            <tbody>
              <tr>
                <td><div class="ol-label">Name</div></td>
                <td>:</td>
                <td>
                  <input type="text" class="form-control" placeholder="Lessee Name" v-model="lesseeName">
                </td>
              </tr>
              <br>
              <tr>
                <td><div class="ol-label">Role</div></td>
                <td>:</td>
                <td>
                  <input type="text" class="form-control" placeholder="Lessee Role" v-model="lesseeRole">
                </td>
              </tr>
              <br>
              <tr>
                <td><div class="ol-label">Phone</div></td>
                <td>:</td>
                <td>
                  <input type="text" name="phone" placeholder="Phone Number" class="form-control" v-model="phoneNumber" @keypress="isNumber($event)" />
                </td>
              </tr>
              <br>
              <tr>
                <td><div class="ol-label">Catatan</div></td>
                <td>:</td>
                <td>
                  <textarea class="form-control" placeholder="Catatan..." v-model="bastNote" rows="3" style="resize: none;"></textarea>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-white btn-sm" data-dismiss="modal" :disabled="isUploading">Batal</button>
        <button type="button" class="btn btn-primary btn-sm" :disabled="searchPic.picId == 'All' || picRole == '' || lesseeName == '' || lesseeRole == '' || bastSign.fileName == '' || phoneNumber == '' || bastNote == '' || isUploading" @click="uploadDoc">
          <span v-if="!isUploading">Simpan</span>
          <span v-else>
            <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
            Loading...
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
export default {
  name: 'UploadBAST',
  props: ['bastData', 'type', 'companyName', 'bastPO', 'orderId', 'bastItem', 'bastLPs'],
  components: {
    Multiselect
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      picSelect: [],
      searchPic: {
        picId: 'All',
        picName: 'All'
      },
      picRole: '',
      lesseeName: '',
      lesseeRole: '',
      bastSign: {
        fileName: '',
        base64: ''
      },
      bastPenyerahan: {
        fileName: '',
        base64: ''
      },
      bastResi: {
        fileName: '',
        base64: ''
      },
      bastNote: '',
      phoneNumber: '',
      loadingTableGenerate: false,
      picId: '',
      fileName1: '',
      fileName2: '',
      fileName3: '',
      isUploading: false
    }
  },
  methods: {
    removeImage (event, type) {
      event.stopPropagation();
      if(type === 'upgrade-file-2') {
        this.bastPenyerahan = {
          fileName: '',
          base64: ''
        }
        this.fileName2 = ''
      } else if(type === 'upgrade-file-3') {
        this.bastResi = {
          fileName: '',
          base64: ''
        }
        this.fileName3 = ''
      }
    },
    mergeProductCode (productId) {
      let mergeCode = "";
      for (var i = 0; i < this.bastLPs.length; i++) {
        if (this.bastLPs[i].productId == productId) {
          if (mergeCode != "") {
            mergeCode = mergeCode + ", " + this.bastLPs[i].productCode;
          } else {
            mergeCode = mergeCode + this.bastLPs[i].productCode;
          }
        }
      }
      return mergeCode;
    },
    checkData() {
      if (this.bastData.senderName) {
        this.picSelect.forEach(el => {
          if (el.picName == this.bastData.senderName) {
            this.searchPic = el
          }
        })
      }
      this.picRole = this.bastData.senderRole
      this.lesseeName = this.bastData.lesseePic
      this.lesseeRole = this.bastData.lesseeRole
      this.phoneNumber = this.bastData.phoneNumber
      // this.bastNote = this.bastData.note
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    triggerFileInput(inputId) {
      document.getElementById(inputId).click();
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('endrent_cache')
      localStorage.removeItem('endrent_cache')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    uploadDoc() {
      this.isUploading = true
      let arrImg = []
      arrImg.push(this.bastSign)
      if (this.bastPenyerahan.fileName !== '') {
        arrImg.push(this.bastPenyerahan)
      }
      if (this.bastResi.fileName !== '') {
        arrImg.push(this.bastResi)
      }
      this.$http.post(process.env.UPLOAD_BAST, {
        bastId: this.bastData.bastId,
        orderId: parseInt(this.orderId),
        asaniPic: this.picId.toString(),
        asaniRole: this.picRole !== null ? this.picRole.replace(this.spaceRegex, ' ') : this.picRole,
        lesseePic: this.lesseeName !== null ? this.lesseeName.replace(this.spaceRegex, ' ') : this.lesseeName,
        lesseeRole: this.lesseeRole !== null ? this.lesseeRole.replace(this.spaceRegex, ' ') : this.lesseeRole,
        note: this.bastNote !== null ? this.bastNote.replace(this.spaceRegex, ' ') : this.bastNote,
        lesseePhone: this.phoneNumber !== null ? this.phoneNumber.replace(this.spaceRegex, ' ') : this.phoneNumber,
        files: arrImg
      }, {
        headers: {
          'Asani-Token': localStorage.getItem('jwt')
        }
      })
      .then(res => {
        if (res.data.status == 200) {
          swal('Success', 'Sukses ' + this.type + ' BAST', 'success')
            .then(() => {
              location.reload()
            })
        } else {
          swal('Error', res.data.message, 'error')
            .then(() => {
              if (res.data.status == 401) {
                this.handleLogout()
              }
            })
        }
      })
      .catch(error => {
        const message = error.response && error.response.data && error.response.data.message || 'An error occurred';
        swal("Sorry", message, "error", {
          button: "Ok",
        }).then(v => {
          const status = error.response && error.response.data && error.response.data.status;
          if(status == 401) {
            this.handleLogout()
          }
        })
      })
      .finally(() => {
        this.isUploading = false
      })
    },
    onFilePicked(e, type) {
      const file = e.target.files[0]
      if (!file) return
      
      const fr = new FileReader()
      fr.readAsDataURL(file)
      fr.addEventListener('load', () => {
        let imgBase64 = fr.result.split("base64,")[1]
        let ext = file.name.toLowerCase().substring(file.name.toLowerCase().lastIndexOf('.') + 1)
        if (ext == "jpeg" || ext == "jpg" || ext == "png" || ext == 'pdf') {
          if (Math.round(file.size / 1024) > 5000) {
            swal('', 'Ukuran file tidak boleh lebih dari 5MB.', 'error')
          } else {
            if (type == 1) {
              this.bastSign = {
                fileName: file.name,
                base64: imgBase64
              }
              this.fileName1 = file.name
            } else if (type == 2) {
              this.bastPenyerahan = {
                fileName: file.name,
                base64: imgBase64
              }
              this.fileName2 = file.name
            } else if (type == 3) {
              this.bastResi = {
                fileName: file.name,
                base64: imgBase64
              }
              this.fileName3 = file.name
            }
          }
        } else {
          swal('', 'Format salah', 'error')
        }
      })
    },
    getPic() {
      this.$http.get(process.env.GET_PIC_NAME, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            this.handleLogout()
          } else {
            this.picSelect = []
            this.picSelect.push({
              picId: 'All',
              picName: 'All'
            })
            this.picSelect.push({
              picId: '0',
              picName: 'None'
            })
            for (var i = 0; i < response.data.content.length; i++) {
              this.picSelect.push({
                picId: response.data.content[i].picId,
                picName: response.data.content[i].picName
              })
            }
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
  },
  watch: {
    bastData() {
      this.checkData()
    }, searchPic(val) {
      this.picId = val.picId
    }
  },
  created() {
    this.getPic()
  }
}
</script>

<style scoped>

* {
  font-family: 'Inter', sans-serif;
}

.card {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background-color: #ffffff;
}

.text-subtitle {
  font-size: 14px;
  color: #62748e;
}

label {
  font-size: 14px;
  color: #2e3646;
  font-weight: 500;
  margin: 0;
}

.ol-label {
  font-size: 14px;
  color: #2e3646;
  font-weight: 500;
}

select.form-control {
  width: 140px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23989898' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 20px center;
  background-size: 1.2em 1.2em;
  padding-right: 20px;
  padding-left: 20px;
}

.modal-body {
  background-color: #f8f9fa !important;
  max-height: 70vh;
  overflow-y: auto;
}

thead {
  background-color: #f4f4f4;
}

thead tr th {
  background-color: #f4f4f4;
  color: #2e3646;
  font-weight: 600;
  font-size: 13px;
}

tbody {
  background-color: white;
}

tbody tr td {
  background-color: white;
  font-size: 13px;
}

input[type="checkbox"] {
  cursor: pointer;
}

tr td {
  vertical-align: top;
}

.btn-back {
  background-color: white;
  color: #007bff;
  border: 1px solid #007bff;
}

.btn-back:hover {
  background-color: #f8f9fa;
  color: #0056b3;
  border-color: #0056b3;
}

.form-control {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  padding: 0.5rem 0.75rem;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

input[type="file"] {
  font-size: 14px;
  cursor: pointer;
}

table {
  width: 100%;
  border-collapse: collapse;
}

table td:first-child {
  padding-left: 0;
}

table td:nth-child(2) {
  width: 5%;
  text-align: center;
  padding: 0 0.5rem;
}

table td:nth-child(3) {
  width: 70%;
  padding-right: 0;
}

.mb-3 {
  margin-bottom: 1.5rem;
}

.mb-2 {
  margin-bottom: 1rem;
}

.p-3 {
  padding: 1.5rem;
}

.w-100 {
  width: 100%;
}

.m-0 {
  margin: 0;
}

.mt-1 {
  margin-top: 0.25rem;
}

.table-fixed {
  table-layout: fixed;
  width: 100%;
}

.fixed-width {
  width: 200px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.hidden-input {
  display: none;
}

.file-input-custom {
  display: flex;
  align-items: center;
  gap: 0;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  padding-right: 30px;
}

.file-button {
  background-color: #EFF8FF;
  color: #247FEC;
  width: 150px;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  flex-shrink: 0;
  border-right: 1px solid #e0e0e0;
}

.file-name {
  flex: 1;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  color: #2e3646;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: #ffffff;
}

.btn {
  border-radius: 8px;
  font-size: 14px;
  padding: 10px 20px;
}

.btn-white {
  background-color: white;
  color: #2E3646;
  border: 1px solid #D1D9E2;
}

.font-14 {
  font-size: 14px !important;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
  display: inline-block;
}

.mr-2 {
  margin-right: 0.5rem;
}

.delete-image-icon {
  position: absolute;
  top: 0px;
  right: 10px;
  color: #ff4d4f;
  font-size: 22px;
}

</style>


// WEBPACK FOOTER //
// src/components/Order/UploadBast.vue